import React, { useState } from 'react';
import { Car, Users, Phone, Shield, CheckCircle, Star, Zap, MessageCircle, ChevronDown, ChevronUp, TrendingUp, Menu, X, ArrowRight, Clock, IndianRupee, MapPin } from 'lucide-react';
import image1 from "../Assets/about-banner-web-1.png"
import image2 from "../Assets/CONVEINCE.jpg"
const AllVehiclePricing = () => {
  const [activeCategory, setActiveCategory] = useState('all');
  const [expandedPackage, setExpandedPackage] = useState(null);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [expandedVehicle, setExpandedVehicle] = useState(null);

  const vehicleData = {
    urbania: {
      title: "Urbania Premium",
      description: "Premium business vehicles for corporate and luxury travel",
      icon: "⭐",
      vehicles: [
        { name: "16 Seater Urbania", seats: 15, ac: true, price: 43, type: "Tempo", features: ["Premium Interior", "AC", "Comfort Seating"], category: "urbania" },
        { name: "12 Seater Urbania", seats: 12, ac: true, price: 39, type: "Tempo", features: ["Luxury Seats", "AC", "Spacious"], category: "urbania" },
        { name: "9 Seater Luxary Urbania", seats: 9, ac: true, price: 55, type: "Tempo", features: ["Executive Class", "AC", "Privacy Glass"], category: "urbania" }
      ]
    },
    tempoTraveller: {
      title: "Tempo Traveller",
      description: "Most popular economical group vehicles",
      icon: "🚐",
      vehicles: [
        { name: "9 Seater Luxury A/C 1+1", seats: 9, ac: true, price: 30, layout: "1+1", features: ["Premium AC", "Luxury Seats"], category: "tempo" },
        { name: "10 Seater Executive A/C 1+1", seats: 10, ac: true, price: 30, layout: "1+1", features: ["Executive", "AC"], category: "tempo" },
        { name: "12 Seater A/C 2+1", seats: 12, ac: true, price: 24, layout: "2+1", features: ["Standard AC", "2+1 Seating"], category: "tempo" },
        { name: "13 Seater A/C 2+1", seats: 13, ac: true, price: 25, layout: "2+1", features: ["Standard AC", "2+1 Seating"], category: "tempo" },
        { name: "12 Seater Luxury A/C 2+1", seats: 12, ac: true, price: 26, layout: "2+1", features: ["Premium AC", "Luxury Interior"], category: "tempo" },
        { name: "13 Seater Luxury A/C 2+1", seats: 13, ac: true, price: 26, layout: "2+1", features: ["Premium AC", "Luxury Interior"], category: "tempo" },
        { name: "14 Seater Luxury A/C 2+1", seats: 14, ac: true, price: 30, layout: "2+1", features: ["Spacious", "Premium AC"], category: "tempo" },
        { name: "15 Seater Luxury A/C 2+2", seats: 15, ac: true, price: 32, layout: "2+2", features: ["Large Group", "Premium AC"], category: "tempo" },
        { name: "16 Seater A/C 2+2", seats: 16, ac: true, price: 32, layout: "2+2", features: ["Large Capacity", "AC"], category: "tempo" },
        { name: "16 Seater Mini Bus A/C 2+1", seats: 16, ac: true, price: 32, layout: "2+1", features: ["Mini Bus", "AC"], category: "tempo" },
        { name: "18 Seater A/C 2+1", seats: 18, ac: true, price: 34, layout: "2+1", features: ["Max Capacity", "AC"], category: "tempo" },
        { name: "12 Seater Non A/C 2+1", seats: 12, ac: false, price: 20, layout: "2+1", features: ["Economical", "2+1 Seating"], category: "tempo" },
        { name: "13 Seater Non A/C 2+1", seats: 13, ac: false, price: 20, layout: "2+1", features: ["Budget", "2+1 Seating"], category: "tempo" },
        { name: "13 Seater Non A/C", seats: 13, ac: false, price: 23, layout: "2+2", features: ["Standard", "Non-AC"], category: "tempo" },
        { name: "14 Seater Non A/C 2+1", seats: 14, ac: false, price: 30, layout: "2+1", features: ["Large Group", "Economical"], category: "tempo" },
        { name: "15 Seater Non A/C 2+2", seats: 15, ac: false, price: 30, layout: "2+2", features: ["Budget", "Large Capacity"], category: "tempo" },
        { name: "16 Seater Non A/C 2+2", seats: 16, ac: false, price: 30, layout: "2+2", features: ["Max Capacity", "Economical"], category: "tempo" }
      ]
    },
    innova: {
      title: "Toyota Innova",
      description: "Comfortable family and business sedans",
      icon: "🚙",
      vehicles: [
        { name: "Innova Crysta", seats: 7, ac: true, price: 20, type: "SUV", features: ["Premium", "7 Seater", "AC"], category: "innova" },
        { name: "Innova Hybrid", seats: 7, ac: true, price: 24, type: "SUV", features: ["Hybrid", "Fuel Efficient", "AC"], category: "innova" }
      ]
    },
    ertiga: {
      title: "Maruti Ertiga",
      description: "Affordable 7-seater MPV",
      icon: "🚗",
      vehicles: [
        { name: "Ertiga", seats: 7, ac: true, price: 17, type: "MPV", features: ["Economical", "7 Seater", "AC"], category: "ertiga" }
      ]
    },
    bus: {
      title: "Mini & Luxury Buses",
      description: "Large group transport vehicles",
      icon: "🚌",
      vehicles: [
        { name: "20 Seater Bus A/C", seats: 20, ac: true, price: 40, type: "Bus", features: ["AC", "Large Group"], category: "bus" },
        { name: "30 Seater Bus A/C", seats: 30, ac: true, price: 55, type: "Bus", features: ["AC", "Very Spacious"], category: "bus" },
        { name: "40 Seater Bus A/C", seats: 40, ac: true, price: 65, type: "Bus", features: ["AC", "Corporate Tours"], category: "bus" },
        { name: "50 Seater Bus A/C", seats: 50, ac: true, price: 70, type: "Bus", features: ["AC", "School/College Trips"], category: "bus" }
      ]
    }
  };

  const allVehicles = [
    ...vehicleData.urbania.vehicles,
    ...vehicleData.tempoTraveller.vehicles,
    ...vehicleData.innova.vehicles,
    ...vehicleData.ertiga.vehicles,
    ...vehicleData.bus.vehicles
  ];

  const filteredVehicles = activeCategory === 'all' 
    ? allVehicles
    : allVehicles.filter(v => v.category === activeCategory);

  const packagePricing = [
    {
      type: "Local Package (8 Hours)",
      vehicles: [
        { name: "10+1 Seater", price: "₹7,500", extraKm: "₹40", extraHour: "₹400" },
        { name: "13+1 Seater", price: "₹8,500", extraKm: "₹45", extraHour: "₹450" },
        { name: "17+1 Seater", price: "₹9,500", extraKm: "₹45", extraHour: "₹450" }
      ]
    },
    {
      type: "Local Package (12 Hours)",
      vehicles: [
        { name: "10+1 Seater", price: "₹10,500", extraKm: "₹40", extraHour: "₹400" },
        { name: "13+1 Seater", price: "₹11,500", extraKm: "₹45", extraHour: "₹450" },
        { name: "17+1 Seater", price: "₹13,500", extraKm: "₹50", extraHour: "₹450" }
      ]
    },
    {
      type: "Outstation (Per Km)",
      vehicles: [
        { name: "10+1 Seater", price: "₹36/Km", bata: "₹700/day" },
        { name: "13+1 Seater", price: "₹38-55/Km", bata: "₹800/day" },
        { name: "17+1 Seater", price: "₹42-65/Km", bata: "₹800/day" }
      ]
    }
  ];

  const categories = [
    { id: 'all', label: 'All Vehicles', color: 'bg-gradient-to-r from-blue-500 to-blue-600' },
    { id: 'urbania', label: 'Urbania', color: 'bg-gradient-to-r from-purple-500 to-purple-600' },
    { id: 'tempo', label: 'Tempo Traveller', color: 'bg-gradient-to-r from-blue-500 to-blue-600' },
    { id: 'innova', label: 'Innova', color: 'bg-gradient-to-r from-green-500 to-green-600' },
    { id: 'ertiga', label: 'Ertiga', color: 'bg-gradient-to-r from-teal-500 to-teal-600' },
    { id: 'bus', label: 'Buses', color: 'bg-gradient-to-r from-red-500 to-red-600' }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-blue-50">
      {/* Header */}
<header className="relative bg-gradient-to-br from-blue-300/90 via-blue-300/90 to-indigo-300/90 text-white py-8 md:py-12 px-4 overflow-hidden">  
  {/* Main background image with overlay */}
  <div 
    className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-40"
    style={{
      backgroundImage: `url("${image1}")`,
      backgroundPosition: 'center 30%',
      opacity: '0.8'
    }}
  ></div>
  
  {/* Secondary texture overlay - increased opacity */}
  {/* <div 
    className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-30"
    style={{
      backgroundImage: 'url("https://images.unsplash.com/photo-1558618666-fcd25c85cd64?auto=format&fit=crop&w=1600&q=80")',
      backgroundPosition: 'center',
      mixBlendMode: 'multiply'
    }}
  ></div> */}
  
  <div className="relative max-w-7xl mx-auto">
    
    {/* SEO Optimized H1 with structured data cues */}
    <div className="text-center mb-6 md:mb-8">
      <div className="flex items-center justify-center gap-3 mb-4">
        {/* <Car className="w-8 h-8 md:w-10 md:h-10 text-yellow-300" /> */}
        <h1 className="text-3xl md:text-5xl font-bold leading-tight">
          <span className="block">Vehicle Rental Price List</span>
          <span className="block text-xl md:text-2xl font-semibold text-blue-100 mt-2">
            Bangalore | Best Rates for Tempo Traveller, Innova & Buses
          </span>
        </h1>
      </div>
      
      {/* Schema-rich description */}
      <div className="max-w-3xl mx-auto">
        <p className="text-lg md:text-xl text-blue-100 mb-6">
          Compare rental prices for <strong className="text-white">Urbania, Tempo Traveller (12-26 Seater), Innova Crysta, Ertiga,</strong> and <strong className="text-white">Luxury Buses</strong> in Bangalore. Transparent pricing with AC/Non-AC options.
        </p>
      </div>
    </div>
    
    {/* Local Business Schema Indicators */}
    <div className="hidden md:flex flex-wrap justify-center gap-3 mb-8 text-sm">
      <span className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full flex items-center gap-2">
        <MapPin className="w-4 h-4" />
        Bangalore Service Area
      </span>
      <span className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full flex items-center gap-2">
        <IndianRupee className="w-4 h-4" />
        Starting ₹15/Km • No Hidden Charges
      </span>
      <span className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full flex items-center gap-2">
        <Clock className="w-4 h-4" />
        24/7 Availability • Instant Booking
      </span>
      <span className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full flex items-center gap-2">
        <Shield className="w-4 h-4" />
        Verified Drivers • Insurance Covered
      </span>
    </div>
    
    {/* Mobile optimized badges */}
    <div className="flex flex-wrap justify-center gap-2 mb-8 md:hidden">
      <span className="bg-white/20 backdrop-blur-sm px-3 py-1 rounded-full text-xs">Bangalore</span>
      <span className="bg-white/20 backdrop-blur-sm px-3 py-1 rounded-full text-xs">From ₹15/Km</span>
      <span className="bg-white/20 backdrop-blur-sm px-3 py-1 rounded-full text-xs">24/7 Service</span>
    </div>
    
    {/* Primary CTA with schema markup */}
    {/* <div className="text-center">
      <a 
        href="tel:+919876543210" 
        className="inline-flex items-center gap-4 bg-gradient-to-r from-yellow-400 to-yellow-500 text-gray-900 px-6 py-4 md:px-10 md:py-5 rounded-xl font-bold hover:from-yellow-300 hover:to-yellow-400 transition-all shadow-2xl hover:shadow-3xl hover:scale-[1.02] max-w-sm w-full md:w-auto mx-auto"
        itemScope
        itemType="https://schema.org/LocalBusiness"
      >
        <Phone className="w-6 h-6 md:w-7 md:h-7" />
        <div className="text-left flex-1" itemProp="telephone">
          <div className="text-xs md:text-sm font-semibold opacity-90">Call for Best Price & Instant Booking</div>
          <div className="text-lg md:text-2xl font-bold tracking-tight">+91 98765 43210</div>
        </div>
        <ArrowRight className="w-5 h-5 md:w-6 md:h-6" />
      </a>
      
      
      <p className="mt-4 text-sm text-blue-100">
        Compare 100+ verified rental providers • Free cancellation • GST invoice available
      </p>
    </div> */}
  </div>
</header>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 py-4 md:py-10">
        {/* Category Filter - Mobile Horizontal Scroll */}
        <div className="mb-4 md:mb-8">
          <div className="md:hidden overflow-x-auto pb-2 -mx-4 px-4">
            <div className="flex gap-2 min-w-max">
              {categories.map((cat) => (
                <button
                  key={cat.id}
                  onClick={() => setActiveCategory(cat.id)}
                  className={`px-4 py-2 rounded-lg font-semibold text-white transition-all ${cat.color} ${
                    activeCategory === cat.id ? 'ring-2 ring-white ring-opacity-50' : 'opacity-90'
                  } whitespace-nowrap`}
                >
                  {cat.label}
                </button>
              ))}
            </div>
          </div>

          {/* Desktop Buttons */}
          <div className="hidden md:flex flex-wrap justify-center gap-3">
            {categories.map((cat) => (
              <button
                key={cat.id}
                onClick={() => setActiveCategory(cat.id)}
                className={`px-6 py-3 rounded-xl font-semibold text-white transition-all ${cat.color} ${
                  activeCategory === cat.id ? 'ring-4 ring-opacity-50 ring-offset-2 scale-105' : 'opacity-90 hover:opacity-100'
                }`}
              >
                {cat.label}
              </button>
            ))}
          </div>
        </div>

        {/* Vehicle Price Section - Mobile Optimized */}
        <div className="mb-6 md:mb-12">
          {/* Mobile View - Card Based */}
          <div className="md:hidden">
            <div className="bg-white rounded-xl shadow-lg overflow-hidden mb-4">
              <div className="bg-gradient-to-r from-blue-600 to-indigo-700 p-4">
                <h2 className="text-lg font-bold text-white text-center">Vehicle Price Comparison</h2>
                <p className="text-blue-100 text-center text-xs mt-1">
                  ₹ per km | Min 80 Kms
                </p>
              </div>
              
              <div className="divide-y divide-gray-100">
                {filteredVehicles.map((vehicle, index) => (
                  <div 
                    key={index} 
                    className={`p-4 ${expandedVehicle === index ? 'bg-blue-50' : 'hover:bg-gray-50'} transition-colors`}
                    onClick={() => setExpandedVehicle(expandedVehicle === index ? null : index)}
                  >
                    <div className="flex items-start justify-between">
                      <div className="flex items-start gap-3 flex-1">
                        <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                          <Car className="w-5 h-5 text-blue-600" />
                        </div>
                        <div className="flex-1 min-w-0">
                          <h3 className="font-bold text-gray-900 text-sm">{vehicle.name}</h3>
                          <div className="flex items-center gap-2 mt-1">
                            <span className="inline-flex items-center gap-1 bg-blue-100 text-blue-800 px-2 py-0.5 rounded-full text-xs">
                              <Users className="w-3 h-3" />
                              {vehicle.seats} seats
                            </span>
                            <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs ${
                              vehicle.ac ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'
                            }`}>
                              {vehicle.ac ? '✅ AC' : '❌ Non-AC'}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="text-right ml-2">
                        <div className="flex items-baseline justify-end gap-1">
                          <span className="text-lg font-bold text-blue-600">₹{vehicle.price}</span>
                          <span className="text-xs text-gray-500">/km</span>
                        </div>
                        <div className="text-xs text-gray-500 mt-1">Min: ₹{vehicle.price * 80}</div>
                      </div>
                    </div>
                    
                    {expandedVehicle === index && (
                      <div className="mt-4 pt-4 border-t border-gray-200">
                        <div className="space-y-3">
                          <div>
                            <h4 className="text-xs font-semibold text-gray-700 mb-1">Best For:</h4>
                            <div className="flex flex-wrap gap-1">
                              {vehicle.features?.map((feat, idx) => (
                                <span key={idx} className="inline-flex items-center gap-1 bg-gray-100 text-gray-700 px-2 py-1 rounded text-xs">
                                  <div className="w-1.5 h-1.5 bg-blue-500 rounded-full"></div>
                                  {feat}
                                </span>
                              ))}
                            </div>
                          </div>
                          <a 
                            href="tel:+919876543210"
                            className="block w-full bg-blue-600 text-white text-center py-2 rounded-lg font-semibold hover:bg-blue-700 transition-all text-sm"
                          >
                            <Phone className="w-4 h-4 inline mr-2" />
                            Book Now
                          </a>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Desktop View - Table (Original) */}
          <div className="hidden md:block bg-white rounded-2xl shadow-xl overflow-hidden">
            <div className="bg-gradient-to-r from-blue-600 to-indigo-700 p-6">
              <h2 className="text-3xl font-bold text-white text-center">
                Complete Vehicle Price Comparison
              </h2>
              <p className="text-blue-100 text-center mt-2">
                All prices in ₹ per kilometer | Minimum booking: 80 Kms
              </p>
            </div>

            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="px-6 py-4 text-left font-bold text-gray-900">Vehicle Type</th>
                    <th className="px-6 py-4 text-left font-bold text-gray-900">Seating</th>
                    <th className="px-6 py-4 text-left font-bold text-gray-900">AC Status</th>
                    <th className="px-6 py-4 text-left font-bold text-gray-900">Price/Km</th>
                    <th className="px-6 py-4 text-left font-bold text-gray-900">Best For</th>
                    <th className="px-6 py-4 text-left font-bold text-gray-900">Action</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {filteredVehicles.map((vehicle, index) => (
                    <tr key={index} className="hover:bg-blue-50 transition-colors">
                      <td className="px-6 py-4">
                        <div className="flex items-center gap-3">
                          <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
                            <Car className="w-6 h-6 text-blue-600" />
                          </div>
                          <div>
                            <div className="font-bold text-gray-900">{vehicle.name}</div>
                            <div className="text-sm text-gray-600">{vehicle.type || 'Tempo'}</div>
                          </div>
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <span className="inline-flex items-center gap-2 bg-blue-100 text-blue-800 px-3 py-1.5 rounded-full font-semibold">
                          <Users className="w-4 h-4" />
                          {vehicle.seats} Seats
                        </span>
                      </td>
                      <td className="px-6 py-4">
                        <span className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full font-semibold ${
                          vehicle.ac 
                            ? 'bg-green-100 text-green-800' 
                            : 'bg-gray-100 text-gray-800'
                        }`}>
                          {vehicle.ac ? '✅ AC' : '❌ Non-AC'}
                        </span>
                      </td>
                      <td className="px-6 py-4">
                        <div>
                          <div className="flex items-baseline gap-1">
                            <span className="text-2xl font-bold text-blue-600">₹{vehicle.price}</span>
                            <span className="text-gray-600 font-medium">/Km</span>
                          </div>
                          <div className="text-sm text-gray-500">Min: ₹{vehicle.price * 80}</div>
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <div className="text-sm text-gray-700 space-y-1">
                          {vehicle.features?.slice(0, 2).map((feat, idx) => (
                            <div key={idx} className="flex items-center gap-1">
                              <div className="w-1.5 h-1.5 bg-blue-500 rounded-full"></div>
                              <span>{feat}</span>
                            </div>
                          ))}
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <a 
                          href="tel:+919876543210"
                          className="inline-flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded-lg font-semibold hover:bg-blue-700 transition-all text-sm"
                        >
                          <Phone className="w-4 h-4" />
                          Book Now
                        </a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Package Pricing Section */}
        <div className="mt-8 md:mt-12">
          <h2 className="text-lg md:text-3xl font-bold text-center text-gray-900 mb-4 md:mb-8">
            Complete Package Pricing
          </h2>
          
          {/* Mobile View - Accordion */}
          <div className="md:hidden space-y-3">
            {packagePricing.map((pkg, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-200">
                <button
                  onClick={() => setExpandedPackage(expandedPackage === index ? null : index)}
                  className="w-full bg-gradient-to-r from-indigo-600 to-purple-600 p-4 text-left flex items-center justify-between"
                >
                  <h3 className="text-base font-bold text-white">{pkg.type}</h3>
                  {expandedPackage === index ? (
                    <ChevronUp className="w-5 h-5 text-white" />
                  ) : (
                    <ChevronDown className="w-5 h-5 text-white" />
                  )}
                </button>
                
                {/* {expandedPackage === index && ( */}
                  <div className="p-4">
                    <div className="space-y-3">
                      {pkg.vehicles.map((vehicle, idx) => (
                        <div key={idx} className="border-b border-gray-100 pb-3 last:border-0">
                          <div className="flex justify-between items-center mb-1">
                            <span className="font-medium text-gray-900">{vehicle.name}</span>
                            <span className="font-bold text-blue-600">{vehicle.price}</span>
                          </div>
                          {pkg.type.includes('Local') ? (
                            <div className="grid grid-cols-2 gap-2 text-xs">
                              <div className="text-gray-600">
                                <div className="font-semibold">Extra Km</div>
                                <div>{vehicle.extraKm}</div>
                              </div>
                              <div className="text-gray-600">
                                <div className="font-semibold">Extra Hour</div>
                                <div>{vehicle.extraHour}</div>
                              </div>
                            </div>
                          ) : (
                            <div className="text-xs text-gray-600">
                              <div className="font-semibold">Driver Bata</div>
                              <div>{vehicle.bata}</div>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                    
                     <div className="mt-4 p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
  <p className="text-sm text-yellow-800">
    <strong>Note:</strong> Meter from office to office. Outstation min 300 km/day.
    Driver bata (6 AM–10 PM), extra after 10 PM. Toll, parking, state permit & GST extra.
  </p>
</div>
                  </div>
                {/* )} */}
              </div>
            ))}
          </div>

          {/* Desktop View - Grid (Original) */}
          <div className="hidden md:grid grid-cols-1 lg:grid-cols-3 gap-6">
            {packagePricing.map((pkg, index) => (
              <div key={index} className="bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-200">
                <div className="bg-gradient-to-r from-indigo-600 to-purple-600 p-5">
                  <h3 className="text-xl font-bold text-white text-center">{pkg.type}</h3>
                </div>
                <div className="p-5">
                  <table className="w-full">
                    <thead>
                      <tr className="border-b">
                        <th className="text-left py-3 font-semibold text-gray-700">Vehicle</th>
                        <th className="text-left py-3 font-semibold text-gray-700">Price</th>
                        {pkg.type.includes('Local') ? (
                          <>
                            <th className="text-left py-3 font-semibold text-gray-700">Extra Km</th>
                            <th className="text-left py-3 font-semibold text-gray-700">Extra Hour</th>
                          </>
                        ) : (
                          <th className="text-left py-3 font-semibold text-gray-700">Driver Bata</th>
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {pkg.vehicles.map((vehicle, idx) => (
                        <tr key={idx} className="border-b last:border-0">
                          <td className="py-3 font-medium text-gray-900">{vehicle.name}</td>
                          <td className="py-3">
                            <span className="font-bold text-blue-600">{vehicle.price}</span>
                          </td>
                          {pkg.type.includes('Local') ? (
                            <>
                              <td className="py-3 text-gray-700">{vehicle.extraKm}</td>
                              <td className="py-3 text-gray-700">{vehicle.extraHour}</td>
                            </>
                          ) : (
                            <td className="py-3 text-gray-700">{vehicle.bata}</td>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  
                  <div className="mt-4 p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
  <p className="text-sm text-yellow-800">
    <strong>Note:</strong> Meter from office to office. Outstation min 300 km/day.
    Driver bata (6 AM–10 PM), extra after 10 PM. Toll, parking, state permit & GST extra.
  </p>
</div>

                </div>
              </div>
            ))}
          </div>
        </div>
      </main>

      {/* Floating Action Buttons - Mobile Only */}
      {/* <div className="fixed bottom-4 right-4 z-50 flex flex-col gap-3 md:hidden">
        <a 
          href="https://wa.me/919876543210"
          className="bg-green-500 text-white p-3 rounded-full shadow-2xl hover:bg-green-600 transition-all hover:scale-110 active:scale-95"
        >
          <MessageCircle className="w-5 h-5" />
        </a>
        <a 
          href="tel:+919876543210"
          className="bg-blue-600 text-white p-3 rounded-full shadow-2xl hover:bg-blue-700 transition-all hover:scale-110 active:scale-95"
        >
          <Phone className="w-5 h-5" />
        </a>
      </div> */}

      {/* Footer */}
      <footer className="relative bg-gradient-to-br from-gray-900 via-gray-800 to-black text-white py-6 md:py-12 px-4 mt-8 md:mt-12">
  {/* Background Image */}
  <div className="absolute inset-0 z-0">
    <img 
      src={image2} 
      alt="Background"
      className="w-full h-full object-cover"
    />
    <div className="absolute inset-0 bg-black/50"></div> {/* Overlay for better text readability */}
  </div>
  
  {/* Content - needs relative and higher z-index */}
  <div className="relative z-10 max-w-7xl mx-auto text-center">
    <h2 className="text-lg md:text-3xl font-bold mb-3 md:mb-6">
      Ready to Book Your Perfect Vehicle?
    </h2>
    <p className="text-gray-300 mb-4 md:mb-8 max-w-3xl mx-auto text-sm md:text-base">
      With over 50+ vehicles in our fleet, we have the perfect transportation solution for every need.
    </p>
    
    <div className="flex flex-col gap-3 md:flex-row md:gap-4 justify-center mb-4 md:mb-8 max-w-2xl mx-auto">
      <a 
        href="tel:+919916788688" 
        className="inline-flex items-center justify-center gap-2 bg-blue-600 text-white px-4 py-3 rounded-xl font-bold hover:bg-blue-700 transition-all text-sm"
      >
        <Phone className="w-4 h-4" />
        <div className="text-left">
          <div className="text-xs">Call for Custom Quote</div>
          <div className="text-base">+91 99647 58999</div>
        </div>
      </a>
      <a 
        href="https://wa.me/919964758999" 
        className="inline-flex items-center justify-center gap-2 bg-green-500 text-white px-4 py-3 rounded-xl font-bold hover:bg-green-600 transition-all text-sm"
      >
        <MessageCircle className="w-4 h-4" />
        <div className="text-left">
          <div className="text-xs">WhatsApp for Booking</div>
          <div className="text-base">Send Requirements</div>
        </div>
      </a>
    </div>
  </div>
</footer>
    </div>
  );
};

export default AllVehiclePricing;